import { render } from "./ApproveForm.vue?vue&type=template&id=25d00196&scoped=true"
import script from "./ApproveForm.vue?vue&type=script&lang=js"
export * from "./ApproveForm.vue?vue&type=script&lang=js"

import "./ApproveForm.vue?vue&type=style&index=0&id=25d00196&scoped=true&lang=css"

import exportComponent from "/home/timecard-test/OggiTimeClockSystem/electron/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25d00196"]])

export default __exports__